import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
const Inquiry = lazy(() => import('@!/Inquiry/containers/Inquiry'))
import { useAppSettings } from '@!/Hooks/useAppSettings'

const InquiryApp = () => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <Inquiry />
      </Suspense>
    </AppProvider>
  )
}

export default InquiryApp
